var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 -9 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 57,
    height: 39,
    rx: 3.5,
    fill: "#fff",
    stroke: "#F3F3F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.917 24.118v-4.512h2.44c1.007 0 1.852-.315 2.538-.948a3.043 3.043 0 001.06-2.365 3.057 3.057 0 00-1.06-2.35 3.605 3.605 0 00-2.537-.965H26.44v11.14h1.477zm0-5.88V14.35h2.477c.553-.016 1.085.2 1.462.59.38.358.594.85.594 1.362a1.87 1.87 0 01-.594 1.361 1.985 1.985 0 01-1.462.576h-2.477zM39.943 17.095c-.632-.565-1.493-.848-2.585-.848-1.403 0-2.462.498-3.177 1.493l1.3.794c.481-.674 1.134-1.011 1.96-1.011a2.131 2.131 0 011.425.521c.39.312.614.777.61 1.267v.327c-.567-.31-1.29-.466-2.167-.466-1.027 0-1.849.234-2.464.7-.615.466-.923 1.093-.923 1.882a2.353 2.353 0 00.875 1.866c.584.498 1.309.747 2.175.747 1.016 0 1.83-.436 2.44-1.307h.065v1.058h1.413V19.42c0-.985-.315-1.76-.947-2.325zm-4.006 5.623a1.132 1.132 0 01-.49-.933c0-.415.2-.761.605-1.046.4-.28.901-.42 1.501-.42.824 0 1.466.178 1.927.533 0 .601-.245 1.125-.734 1.571a2.394 2.394 0 01-1.662.669 1.84 1.84 0 01-1.147-.374zM49 16.496l-4.932 10.982h-1.525l1.83-3.843-3.243-7.139h1.606l2.344 5.476h.032l2.28-5.476H49z",
    fill: "#5F6368"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.949 18.635c0-.436-.038-.872-.114-1.302h-6.23v2.465h3.568a2.958 2.958 0 01-1.319 1.945v1.6h2.13c1.246-1.114 1.965-2.76 1.965-4.708z",
    fill: "#4285F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.605 24.889c1.783 0 3.284-.567 4.378-1.545l-2.129-1.6c-.592.39-1.356.611-2.248.611a3.94 3.94 0 01-3.709-2.641H9.704v1.649c1.12 2.161 3.404 3.526 5.901 3.526z",
    fill: "#34A853"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.897 19.714a3.721 3.721 0 010-2.45v-1.649H9.704a6.223 6.223 0 000 5.748l2.193-1.65z",
    fill: "#FBBC04"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.605 14.622a3.65 3.65 0 012.535.96l1.885-1.826a6.461 6.461 0 00-4.42-1.667c-2.497 0-4.78 1.364-5.901 3.526l2.193 1.649a3.94 3.94 0 013.708-2.642z",
    fill: "#EA4335"
  })));
}
export default SvgGooglePay;